var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46573 17.5652L1.11606 10.2155C0.536378 9.63586 0.536378 8.69574 1.11606 8.1175L8.46573 0.767826C9.04541 0.188147 9.98556 0.188147 10.5652 0.767826C11.1449 1.3475 11.1449 2.28765 10.5652 2.86733L4.266 9.16652L10.5652 15.4657C11.1449 16.0454 11.1449 16.9856 10.5652 17.5652C9.98556 18.1449 9.04541 18.1449 8.46573 17.5652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousicon);
export default __webpack_public_path__ + "static/media/previousicon.63bdfea3e597ae8b28c907eaa1418f7d.svg";
export { ForwardRef as ReactComponent };